import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { NgxSliderComponent } from './ngx-slider/ngx-slider.component';

@NgModule({
  imports: [CommonModule],
  declarations: [NgxSliderComponent],
  exports: [NgxSliderComponent],
})
export class NgxSliderModule {}
